import React, { useRef, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUploadCloud, FiCheckCircle, FiLoader } = FiIcons;

export default function UploadZone({ title, description, onUpload, isUploading }) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    try {
      await onUpload(file);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (error) {
      console.error('Upload failed', error);
    }
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const onDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const onDragLeave = () => setIsDragging(false);
  const onDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFile(e.dataTransfer.files[0]);
  };

  return (
    <div
      onClick={() => !isUploading && fileInputRef.current?.click()}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      className={`relative overflow-hidden rounded-3xl border-2 border-dashed p-12 text-center cursor-pointer transition-all duration-300 ${
        isDragging
          ? 'border-blue-500 bg-blue-50/50'
          : success
          ? 'border-green-500 bg-green-50/50'
          : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50/50'
      } bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)]`}
    >
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        accept=".xlsx, .xls"
        onChange={(e) => handleFile(e.target.files[0])}
        disabled={isUploading}
      />
      
      <div className="flex flex-col items-center justify-center space-y-4">
        {isUploading ? (
          <SafeIcon icon={FiLoader} className="text-4xl text-blue-500 animate-spin" />
        ) : success ? (
          <SafeIcon icon={FiCheckCircle} className="text-4xl text-green-500" />
        ) : (
          <SafeIcon icon={FiUploadCloud} className={`text-4xl ${isDragging ? 'text-blue-500' : 'text-gray-400'}`} />
        )}
        
        <div>
          <h3 className="text-xl font-semibold tracking-tight text-gray-900">
            {isUploading ? 'Processing...' : success ? 'Upload Complete' : title}
          </h3>
          <p className="text-sm text-gray-500 mt-2 max-w-sm mx-auto">
            {isUploading ? 'Parsing and updating database...' : description}
          </p>
        </div>
        
        {!isUploading && !success && (
          <div className="mt-6 px-6 py-2 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors">
            Browse Files
          </div>
        )}
      </div>
    </div>
  );
}